import React, { useEffect } from 'react';
import { Box, Container, Typography, Button, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

function LoginPage() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        textAlign="center"
      >
        <Typography variant="h3" color="primary" gutterBottom fontWeight={700}>
          RITTEC Learn
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Die Lernplattform für RITTER Technologie Mitarbeiter
        </Typography>
        <Button variant="contained" size="large" onClick={login}>
          Mit RITTEC Account anmelden
        </Button>
      </Box>
    </Container>
  );
}

export default LoginPage;
